// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarMinimal_navbar__Zgtw8","navbarMain":"NavbarMinimal_navbarMain__u6G6X","link":"NavbarMinimal_link__tlhX4"};